import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { MachineInfo, MachineService } from '../api/api_pb';
import { useClient } from '../connect_api';
import { useGlobalContext } from '../GlobalContext';

export function useMachineByUuid(machineUuid: string | undefined) {
    const location = useLocation();
    const machineClient = useClient(MachineService);
    const { findMachineInfoByUuid, updateMachineInfos } = useGlobalContext();

    const [machine, setMachine] = useState<MachineInfo | undefined>(() => {
        return location.state?.machine || (machineUuid ? findMachineInfoByUuid(machineUuid) : undefined);
    });
    const [isLoading, setIsLoading] = useState(!machine);

    const fetchMachine = useCallback(async () => {
        if (!machineUuid) return;
        try {
            const response = await machineClient.listMachines({});
            const found = response.machines.find(m => m.uuid === machineUuid);
            if (found) {
                setMachine(found);
                updateMachineInfos(found);
            }
        } catch (error) {
            console.error('Failed to fetch machine:', error);
        } finally {
            setIsLoading(false);
        }
    }, [machineUuid, machineClient, updateMachineInfos]);

    useEffect(() => {
        if (machine) {
            setIsLoading(false);
            return;
        }
        fetchMachine();
    }, [machine, fetchMachine]);

    return { machine, isLoading };
}
